import { AuthMethod } from './auth-method';
import { BuildingAuthorization } from './building-authorization.interface';
import { GlobalAuthority } from './global-authority';
import { UserManagingCompanyAuthorities } from '@app/shared/models/managing-company-authorities.interface';

export class User {
  id: number;
  name: string;
  pictureUrl: string;
  emailAddress: string;
  authKey: string;
  authMethod: AuthMethod;
  managingCompanyIds: number[];
  globalAuthorities: GlobalAuthority[];
  buildingAuthorizations: BuildingAuthorization[];
  managingCompanyAuthorities?: UserManagingCompanyAuthorities[];
  headline: string;
  joinedAt: string;
  tenantsMap: {};
  authSource: string;
  lastLoggedIn: Date;

  constructor(
    id: number,
    name: string,
    pictureUrl: string,
    emailAddress: string,
    authKey: string,
    authMethod: AuthMethod,
    managingCompanyIds: number[],
    globalAuthorities: GlobalAuthority[],
    buildingAuthorizations: BuildingAuthorization[],
    managingCompanyAuthorities: UserManagingCompanyAuthorities[] = [],
    headline: string,
    joinedAt: string,
    tenantsMap: {},
    authSource: string,
    lastLoggedIn: Date
  ) {
    this.id = id;
    this.name = name;
    this.pictureUrl = pictureUrl;
    this.emailAddress = emailAddress;
    this.authKey = authKey;
    this.authMethod = authMethod;
    this.managingCompanyIds = managingCompanyIds;
    this.globalAuthorities = globalAuthorities;
    this.buildingAuthorizations = buildingAuthorizations;
    this.managingCompanyAuthorities = managingCompanyAuthorities;
    this.headline = headline;
    this.joinedAt = joinedAt;
    this.tenantsMap = tenantsMap;
    this.authSource = authSource;
    this.lastLoggedIn = lastLoggedIn;
  }
}
